/**
 * Card 1359: ephemeral auth-runtime (cloud-only personal-provider sign-in).
 * Uses the forge-server CMMD proxy prefix (/api/cmmd/*), which rewrites to
 * https://cmmd.ai/api/forge/context/auth-runtime. Hitting /api/forge/context/*
 * directly is NOT proxied and falls through to the SPA fallback.
 *
 * @module environments/cmmdApi/authRuntime
 */
import type { CmmdAuthRuntimeConnectDescriptor, CmmdAuthRuntimeState } from "@cmmd-forge/contracts";

import { request, type TransportConfig } from "./transport";

/** The client surface these calls appear on. */
export interface AuthRuntimeApi {
  provisionAuthRuntime(): Promise<CmmdAuthRuntimeState>;
  getAuthRuntimeState(): Promise<CmmdAuthRuntimeState>;
  destroyAuthRuntime(): Promise<CmmdAuthRuntimeState>;
  connectAuthRuntime(): Promise<CmmdAuthRuntimeConnectDescriptor>;
}

const AUTH_RUNTIME_PATH = "/api/cmmd/auth-runtime";

export function provisionAuthRuntime(cfg: TransportConfig): Promise<CmmdAuthRuntimeState> {
  return request<CmmdAuthRuntimeState>({ method: "POST", path: AUTH_RUNTIME_PATH }, cfg);
}

export function getAuthRuntimeState(cfg: TransportConfig): Promise<CmmdAuthRuntimeState> {
  return request<CmmdAuthRuntimeState>({ method: "GET", path: AUTH_RUNTIME_PATH }, cfg);
}

export function destroyAuthRuntime(cfg: TransportConfig): Promise<CmmdAuthRuntimeState> {
  return request<CmmdAuthRuntimeState>({ method: "DELETE", path: AUTH_RUNTIME_PATH }, cfg);
}

export function connectAuthRuntime(
  cfg: TransportConfig,
): Promise<CmmdAuthRuntimeConnectDescriptor> {
  return request<CmmdAuthRuntimeConnectDescriptor>(
    { method: "POST", path: `${AUTH_RUNTIME_PATH}/connect` },
    cfg,
  );
}
